import React, {useEffect, useState} from 'react';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col';
import CkEditor from '../ckeditor';
import 'react-dropzone-uploader/dist/styles.css'
import CustomDropzone from "../customDropzone";

function Template8(props) {
    const {values,index,setFieldValue,name,moduleErrors,moduleTouched} = props
    return (
        <div className="templates-wrap">
            <Row>

                <Col md={12}>

                        <CkEditor moduleErrors={moduleErrors} moduleTouched={moduleTouched} name={`modules.${index}.contents`} setFieldValue={setFieldValue} values={values} index={index}/>

                </Col>
                <Col md={12}>
                    <div className="image-min-size m-t-20">
                    <CustomDropzone  moduleErrors={moduleErrors} moduleTouched={moduleTouched} name={`modules.${index}.image`} setFieldValue={setFieldValue} values={values} index={index}/>
                    </div>
                    {moduleErrors?.image && moduleTouched?.image &&
                    <span className={`form-error text-danger`} style={{display:'block'}}>{moduleErrors?.image}</span>}

                </Col>

            </Row>

        </div>
    )
};
export default Template8;
